export const SUBJECTS = 'Fag';